import React from 'react'
import "./Overview.css"



function Overview() {
    return (
        <div>
            <div className="about">
                <h3>About Live Demo</h3>
                <p> Lorem ipsum dolor sit amet, consectetur elit.
                     Proin finibus vitae turpis non iaculis.
                      Quisque nec erat eu, diam egestas dapibus nec 
                      non ante adipiscing Vivam molestie sodales congue.
                       Aenean tincidunt erat non nulla iaculis, non pretium odio feugiat. </p>
            </div>
            <div className="about">
                <h3>What you will learn</h3>
                <p>Lorem ipsum dolor sit amet, consectetur elit. 
                   Proin finibus vitae turpis non iaculis. 
                   Quisque nec erat eu  egestas dapibus 
                   Nec non ante adipiscing  Vivamus molestie
                   Sodales congue. Aenean tincidunt erat non </p>
            </div>

            
            
        </div>
    )
}

export  {Overview}
